import React from 'react';
import globalConfig from 'react-global-configuration';
import { Slide, toast } from 'react-toastify';
import { Icon, Text } from '../../ui-kit';












function getClickHandler({ history, link, windowLink }) {
  if (history && link) {
    return ({ target }) => {
      if (!target.classList.contains('icon')) {
        history.push(link);
      }
    };
  }

  if (windowLink) {
    return () => {
      window.location.href = windowLink;
    };
  }

  return () => {};
}

const defaults = (params = {}) => ({
  hideProgressBar: true,
  closeButton: <Icon name="close" size={10} color="white" />,
  draggable: false,
  transition: Slide,
  onClick: getClickHandler(params)
});

let activeToasts = [];
const toastQueue = [];
let MAX_TOASTS = 5;

function processQueue() {
  while (toastQueue.length > 0 && activeToasts.length < MAX_TOASTS) {
    const next = toastQueue.shift();
    if (next) next();
  }
}

function showToast(content, options = {}, type = 'info') {
  const create = () => {
    const id = toast[type](content, {
      ...options,
      onClose: () => {
        activeToasts = activeToasts.filter((t) => t !== id);
        if (options.onClose) options.onClose();
        processQueue();
      }
    });

    activeToasts.push(id);
    if (options.onOpen) options.onOpen();
  };

  if (activeToasts.length < MAX_TOASTS) {
    create();
  } else {
    toastQueue.push(create);
  }
}

function buildContent(content, title) {
  return (
    <div className="Toastify__toast__content">
      {title && <Text darkTheme highlighted noMargin>{title}</Text>}
      <Text darkTheme noMargin label>{content}</Text>
    </div>);

}

function getDefaultTitle(type, title) {
  if (title) return title;

  switch (type) {
    case 'error':
      return 'Something went wrong...';
    case 'success':
      return 'Success!';
    default:
      return null;
  }
}

function notify(params) {
  if (typeof params === 'string') {
    return showToast(buildContent(params), defaults());
  }

  const {
    content,
    type = 'info',
    history,
    link,
    windowLink,
    limit,
    title: customTitle
  } = params;

  const skipNotifications = globalConfig.get('skipNotifications');
  if (skipNotifications && type === 'error') {
    return null;
  }

  if (limit) {
    MAX_TOASTS = limit;
    return showToast(
      buildContent(content, getDefaultTitle(type, customTitle)),
      defaults({ history, link, windowLink }),
      type);
  }

  const title = getDefaultTitle(type, customTitle);
  const options = defaults({ history, link, windowLink });

  return toast[type](buildContent(content, title), options);
}

export default notify;